/** Shared installation action for floating, mobile and staff-menu entry points. */
export function usePwaInstallAction() {
  const { $pwaInstall: installation } = useNuxtApp()
  const instructionsOpen = useState<boolean>('pwa-install-instructions-open', () => false)
  const failed = useState<boolean>('pwa-install-failed', () => false)

  async function install() {
    failed.value = false
    if (!installation || installation.ios || !installation.available.value) {
      instructionsOpen.value = true
      return
    }
    try {
      if (!(await installation.install())) instructionsOpen.value = true
    } catch {
      failed.value = true
      instructionsOpen.value = true
    }
  }

  return { installation, instructionsOpen, failed, install }
}
